import * as angular from "angular";
import {IController} from "angular";

export class AccountsCommissionsSummaryViewCtrl implements IController {

  public queryString: string;

  constructor() {
  }

  $onInit() {

  }

  onQueryChange(queryString) {
    this.queryString = queryString;
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountsCommissionsSummaryView', {
    bindings: {},
    template: require('./accounts-commissions-summary-view.html').default,
    controller: AccountsCommissionsSummaryViewCtrl
  });
